import { Modal } from '@mui/material';
import React from 'react';
import { FiAlertTriangle, FiX } from 'react-icons/fi';
import './style.css';

const DeletePopUp = ({ open, handleClose, submitText, handleSubmit, handleCancel, cancelText, heading, text }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <div className="delete-popup-overlay">
        <div className="delete-popup-container">
          <button className="delete-popup-close" onClick={handleClose}>
            <FiX size={18} />
          </button>
          <div className="delete-popup-icon">
            <FiAlertTriangle size={28} />
          </div>
          <div className="delete-popup-content">
            <h2 className="delete-popup-heading">{heading}</h2>
            <p className="delete-popup-text">{text}</p>
          </div>
          <div className="delete-popup-actions">
            <button className="delete-popup-cancel" onClick={handleCancel}>
              {cancelText}
            </button>
            <button className="delete-popup-submit" onClick={handleSubmit}>
              {submitText}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeletePopUp;
